export const TOOlTIP_FIELDS = {
  qaSpecificationStatus: {
    fieldPath: 'qaSpecification.status',
  },
  // allergens
  allergenIsPresent: {
    fieldPath:
      'qaSpecification.allergens.allergenRelatedInformation.allergen.isPresent',
  },

  allergenTypeCode: {
    fieldPath:
      'qaSpecification.allergens.allergenRelatedInformation.allergen.allergenTypeCode',
  },

  levelOfContainmentCode: {
    fieldPath:
      'qaSpecification.allergens.allergenRelatedInformation.allergen.levelOfContainmentCode',
  },
  containmentSource: {
    fieldPath:
      'qaSpecification.allergens.allergenRelatedInformation.allergen.containmentSource',
  },
  // Formula Fields
  formulaActiveIngredients: {
    fieldPath: 'qaSpecification.formula.activeIngredients',
  },
  formulaInactiveIngredients: {
    fieldPath: 'qaSpecification.formula.inactiveIngredients',
  },
  formulaIngredientsPurposeStrength: {
    fieldPath: 'qaSpecification.formula.ingredientsPurposeStrength',
  },
  formulaOtherIngredients: {
    fieldPath: 'qaSpecification.formula.otherIngredients',
  },
  formulaProductClaims: {
    fieldPath: 'qaSpecification.formula.productClaims',
  },
  formulaFreeFrom: {
    fieldPath: 'qaSpecification.formula.freeFrom',
  },
  formulaIngredientDefinitions: {
    fieldPath: 'qaSpecification.formula.ingredientDefinitions',
  },
  formulaEpaRegistrationNumber: {
    fieldPath: 'qaSpecification.formula.epaRegistrationNumber',
  },
  formulaFormula: {
    fieldPath: 'qaSpecification.formula.formula',
  },
  // Formula Grid Columns
  formulaSalesDesignation: {
    fieldPath: 'qaSpecification.formula.formula.salesDesignation',
  },
  formulaTechnicalDesignation: {
    fieldPath: 'qaSpecification.formula.formula.technicalDesignation',
  },
  formulaCasNumber: {
    fieldPath: 'qaSpecification.formula.formula.casNumber',
  },
  formulaCountry: {
    fieldPath: 'qaSpecification.formula.formula.country',
  },
  formulaFunction: {
    fieldPath: 'qaSpecification.formula.formula.function',
  },
  formulaClassificationAndRiskPhrases: {
    fieldPath: 'qaSpecification.formula.formula.classificationAndRiskPhrases',
  },
  formulaOrigin: {
    fieldPath: 'qaSpecification.formula.formula.origin',
  },
  formulaOriginSpecification: {
    fieldPath: 'qaSpecification.formula.formula.originSpecification',
  },
  formulaPercentOfRawMaterialSubstance: {
    fieldPath: 'qaSpecification.formula.formula.percentOfRawMaterialSubstance',
  },
  formulaPercentOfIncorporatedRawMaterial: {
    fieldPath:
      'qaSpecification.formula.formula.percentOfIncorporatedRawMaterial',
  },
  formulaPercentOfFinishedProductSubstance: {
    fieldPath:
      'qaSpecification.formula.formula.percentOfFinishedProductSubstance',
  },
  formulaDocuments: {
    fieldPath: 'qaSpecification.formula.formula.documents',
  },
  // certificate
  certificateStatus: {
    fieldPath: 'qaSpecification.certificate.status',
  },
  certificateType: {
    fieldPath: 'qaSpecification.certificate.certificateType',
  },
  type: {
    fieldPath: 'qaSpecification.certificate.type',
  },
  documentName: {
    fieldPath: 'qaSpecification.certificate.documentName',
  },
  certificateName: {
    fieldPath: 'qaSpecification.certificate.certificateName',
  },
  certificateSubType: {
    fieldPath: 'qaSpecification.certificate.subtype',
  },
  certificateBody: {
    fieldPath: 'qaSpecification.certificate.certificateBody',
  },
  certificateExpiryDate: {
    fieldPath: 'qaSpecification.certificate.certificateExpiryDate',
  },
  characteristicType: {
    fieldPath: 'qaSpecification.certificate.characteristicType',
  },
  certificateFileType: {
    fieldPath: 'qaSpecification.certificate.fileType',
  },
  certificateFileSize: {
    fieldPath: 'qaSpecification.certificate.fileSize',
  },
  certificateUploadDate: {
    fieldPath: 'qaSpecification.certificate.uploadDate',
  },
  productSpecificationCertificateBadge: {
    fieldPath: 'qaSpecification.productSpecification.certificateBadge',
  },
  productSpecificationSupportingDocument: {
    fieldPath: 'qaSpecification.productSpecification.supportingDocument',
  },
  labelType: {
    fieldPath: 'qaSpecification.factPanels.nutritionalInformation.labelType',
  },
  ingredientNotice: {
    fieldPath:
      'qaSpecification.factPanels.nutritionalInformation.ingredientNotice',
  },
  nutritionFdaLabelFootNote: {
    fieldPath:
      'qaSpecification.factPanels.nutritionalInformation.fdaLabelFootNote',
  },
  factPanelsLanguageCode: {
    fieldPath: 'qaSpecification.factPanels.nutritionalInformation.languageCode',
  },
  servingsPerContainer: {
    fieldPath:
      'qaSpecification.factPanels.nutritionalInformation.servingsPerContainer',
  },
  //Nutrient Form Specific Fields
  nutritionTypeCode: {
    fieldPath:
      'qaSpecification.factPanels.nutritionalInformation.nutritionDetails.nutritionTypeCode',
  },
  measurementPrecisionCode: {
    fieldPath:
      'qaSpecification.factPanels.nutritionalInformation.nutritionDetails.measurementPrecision',
  },
  dailyValueIntakePercent: {
    fieldPath:
      'qaSpecification.factPanels.nutritionalInformation.nutritionDetails.dailyValueIntakePercent',
  },
  quantity: {
    fieldPath:
      'qaSpecification.factPanels.nutritionalInformation.nutritionDetails.quantity',
  },
  quantityUom: {
    fieldPath:
      'qaSpecification.factPanels.nutritionalInformation.nutritionDetails.quantityUom',
  },
  dailyValuePrecision: {
    fieldPath:
      'qaSpecification.factPanels.nutritionalInformation.nutritionDetails.dailyValuePrecision',
  },
  // Supplement Information Specific Fields
  supplementTypeCode: {
    fieldPath:
      'qaSpecification.factPanels.supplementInformation.supplementTypeCode',
  },
  supplementUnitOfMeasure: {
    fieldPath: 'qaSpecification.factPanels.supplementInformation.unitOfMeasure',
  },
  // Added Supplement Information Fields
  supplementServingSize: {
    fieldPath: 'qaSpecification.factPanels.supplementInformation.servingSize',
  },
  supplementServingSizeMeasurement: {
    fieldPath:
      'qaSpecification.factPanels.supplementInformation.servingSizeMeasurement',
  },
  supplementServingSizeDescription: {
    fieldPath:
      'qaSpecification.factPanels.supplementInformation.servingSizeDescription',
  },
  supplementServingPerContainerDescriptor: {
    fieldPath:
      'qaSpecification.factPanels.supplementInformation.servingPerContainerDescriptor',
  },
  supplementNumberOfServingsPerContainer: {
    fieldPath:
      'qaSpecification.factPanels.supplementInformation.numberOfServingsPerContainer',
  },
  supplementCalories: {
    fieldPath: 'qaSpecification.factPanels.supplementInformation.calories',
  },
  supplementCaloriesFromFat: {
    fieldPath:
      'qaSpecification.factPanels.supplementInformation.caloriesFromFat',
  },
  supplementFdaLabelFootNote: {
    fieldPath:
      'qaSpecification.factPanels.supplementInformation.fdaLabelFootNote',
  },
  supplementOtherIngredients: {
    fieldPath:
      'qaSpecification.factPanels.supplementInformation.otherIngredients',
  },
  supplementLanguageCode: {
    fieldPath: 'qaSpecification.factPanels.supplementInformation.languageCode',
  },
  // Nutrients
  nutrientNutritionName: {
    fieldPath:
      'qaSpecification.factPanels.supplementInformation.nutrients.nutritionName',
  },
  nutrientIngredientsPartOf: {
    fieldPath:
      'qaSpecification.factPanels.supplementInformation.nutrients.ingredientsPartOf',
  },
  nutrientDescriptor: {
    fieldPath:
      'qaSpecification.factPanels.supplementInformation.nutrients.descriptor',
  },
  nutrientQuantityPrecision: {
    fieldPath:
      'qaSpecification.factPanels.supplementInformation.nutrients.quantityPrecision',
  },
  nutrientQuantity: {
    fieldPath:
      'qaSpecification.factPanels.supplementInformation.nutrients.quantity',
  },
  nutrientQuantityUom: {
    fieldPath:
      'qaSpecification.factPanels.supplementInformation.nutrients.quantityUom',
  },
  nutrientQuantityDescription: {
    fieldPath:
      'qaSpecification.factPanels.supplementInformation.nutrients.quantityDescription',
  },
  nutrientDailyValue: {
    fieldPath:
      'qaSpecification.factPanels.supplementInformation.nutrients.dailyValue',
  },
  supplementDailyValuePrecision: {
    fieldPath:
      'qaSpecification.factPanels.supplementInformation.nutrients.dailyValuePrecision',
  },
  nutrientDailySymbol: {
    fieldPath:
      'qaSpecification.factPanels.supplementInformation.nutrients.dailySymbol',
  },
  nutrientItalicNutrient: {
    fieldPath:
      'qaSpecification.factPanels.supplementInformation.nutrients.italicNutrient',
  },
  nutrientItalicDescriptor: {
    fieldPath:
      'qaSpecification.factPanels.supplementInformation.nutrients.italicDescriptor',
  },
  // Dietary Ingredients
  dietaryIngredientName: {
    fieldPath:
      'qaSpecification.factPanels.supplementInformation.dietaryIngredients.ingredientName',
  },
  dietaryIngredientsPartOf: {
    fieldPath:
      'qaSpecification.factPanels.supplementInformation.dietaryIngredients.ingredientsPartOf',
  },
  dietaryDescriptor: {
    fieldPath:
      'qaSpecification.factPanels.supplementInformation.dietaryIngredients.descriptor',
  },
  dietaryQuantityPrecision: {
    fieldPath:
      'qaSpecification.factPanels.supplementInformation.dietaryIngredients.quantityPrecision',
  },
  dietaryQuantity: {
    fieldPath:
      'qaSpecification.factPanels.supplementInformation.dietaryIngredients.quantity',
  },
  dietaryQuantityUom: {
    fieldPath:
      'qaSpecification.factPanels.supplementInformation.dietaryIngredients.quantityUom',
  },
  dietaryQuantityDescription: {
    fieldPath:
      'qaSpecification.factPanels.supplementInformation.dietaryIngredients.quantityDescription',
  },
  dietaryDailySymbol: {
    fieldPath:
      'qaSpecification.factPanels.supplementInformation.dietaryIngredients.dailySymbol',
  },
  dietaryItalicDietary: {
    fieldPath:
      'qaSpecification.factPanels.supplementInformation.dietaryIngredients.italicDietary',
  },
  dietaryItalicDescriptor: {
    fieldPath:
      'qaSpecification.factPanels.supplementInformation.dietaryIngredients.italicDescriptor',
  },
  // Drug facts
  drugFactLabelType: {
    fieldPath: 'qaSpecification.factPanels.drugInformation.labelType',
  },
  drugFactAgeGroup: {
    fieldPath: 'qaSpecification.factPanels.drugInformation.directions.ageGroup',
  },
  drugFactDirectionDosage: {
    fieldPath:
      'qaSpecification.factPanels.drugInformation.directions.directionDosage',
  },
  drugFactUses: {
    fieldPath: 'qaSpecification.factPanels.drugInformation.uses.useText',
  },
  drugFactUseDetail: {
    fieldPath: 'qaSpecification.factPanels.drugInformation.uses.useDetail',
  },
  drugFactDosageUnit: {
    fieldPath: 'qaSpecification.factPanels.drugInformation.dosageUnit',
  },
  // Active Ingredients
  activeIngredientName: {
    fieldPath:
      'qaSpecification.factPanels.drugInformation.activeIngredients.ingredientName',
  },
  activeIngredientPurposeDescriptor: {
    fieldPath:
      'qaSpecification.factPanels.drugInformation.activeIngredients.purposeDescriptor',
  },
  activeIngredientQuantityPrecision: {
    fieldPath:
      'qaSpecification.factPanels.drugInformation.activeIngredients.quantityPrecision',
  },
  activeIngredientQuantity: {
    fieldPath:
      'qaSpecification.factPanels.drugInformation.activeIngredients.quantity',
  },
  activeIngredientQuantityUom: {
    fieldPath:
      'qaSpecification.factPanels.drugInformation.activeIngredients.quantityUom',
  },
  activeIngredientItalicName: {
    fieldPath:
      'qaSpecification.factPanels.drugInformation.activeIngredients.italicName',
  },
  activeIngredientItalicPurposeDescriptor: {
    fieldPath:
      'qaSpecification.factPanels.drugInformation.activeIngredients.italicPurposeDescriptor',
  },
  // Inactive Ingredients
  inactiveIngredients: {
    fieldPath: 'qaSpecification.factPanels.drugInformation.inactiveIngredients',
  },
  warningText: {
    fieldPath:
      'qaSpecification.factPanels.drugInformation.warnings.warningText',
  },
  warningDetail: {
    fieldPath:
      'qaSpecification.factPanels.drugInformation.warnings.warningDetail',
  },
  boldText: {
    fieldPath: 'qaSpecification.factPanels.drugInformation.warnings.boldText',
  },
  boldDetail: {
    fieldPath: 'qaSpecification.factPanels.drugInformation.warnings.boldDetail',
  },
  otherInformation: {
    fieldPath: 'qaSpecification.factPanels.drugInformation.otherInformation',
  },
  // Pet Food
  petNutritionLabelType: {
    fieldPath: 'qaSpecification.factPanels.petNutritionalInformation.labelType',
  },
  petNutritionMeasurementPerCup: {
    fieldPath:
      'qaSpecification.factPanels.petNutritionalInformation.measurementPerCup',
  },
  petNutritionMeasurementUomPerCup: {
    fieldPath:
      'qaSpecification.factPanels.petNutritionalInformation.measurementUomPerCup',
  },
  petNutritionCalorieContent: {
    fieldPath:
      'qaSpecification.factPanels.petNutritionalInformation.calorieContent',
  },
  petNutritionCaloriesPerCup: {
    fieldPath:
      'qaSpecification.factPanels.petNutritionalInformation.caloriesPerCup',
  },
  petNutritionProtein: {
    fieldPath: 'qaSpecification.factPanels.petNutritionalInformation.protein',
  },
  petNutritionFat: {
    fieldPath: 'qaSpecification.factPanels.petNutritionalInformation.fat',
  },
  petNutritionCarbohydrate: {
    fieldPath:
      'qaSpecification.factPanels.petNutritionalInformation.carbohydrate',
  },
  petNutritionFdaLabelFootNote: {
    fieldPath:
      'qaSpecification.factPanels.petNutritionalInformation.fdaLabelFootNote',
  },
  petNutritionEnzymesAndMicroorganisms: {
    fieldPath:
      'qaSpecification.factPanels.petNutritionalInformation.enzymesAndMicroorganisms',
  },
  petNutritionNutritionalAdequacyStatement: {
    fieldPath:
      'qaSpecification.factPanels.petNutritionalInformation.nutritionalAdequacyStatement',
  },
  // Pet Nutrition Nutrients
  petNutrientName: {
    fieldPath:
      'qaSpecification.factPanels.petNutritionalInformation.nutrients.nutrientName',
  },
  petNutrientLimit: {
    fieldPath:
      'qaSpecification.factPanels.petNutritionalInformation.nutrients.limit',
  },
  petNutrientGuaranteed: {
    fieldPath:
      'qaSpecification.factPanels.petNutritionalInformation.nutrients.guaranteed',
  },
  petNutrientGuaranteedUom: {
    fieldPath:
      'qaSpecification.factPanels.petNutritionalInformation.nutrients.guaranteedUom',
  },
  petNutrientQuantity: {
    fieldPath:
      'qaSpecification.factPanels.petNutritionalInformation.nutrients.quantity',
  },
  petNutrientQuantityUom: {
    fieldPath:
      'qaSpecification.factPanels.petNutritionalInformation.nutrients.quantityUom',
  },

  // components
  caS_INCI_HSCode: {
    fieldPath: 'qaSpecification.components.components.caS_INCI_HSCode',
  },
  component: {
    fieldPath: 'qaSpecification.components.components.component',
  },
  componentsCountryOfOrigin: {
    fieldPath:
      'qaSpecification.components.components.componentsCountryOfOrigin',
  },
  componentsFunction: {
    fieldPath: 'qaSpecification.components.components.componentsFunction',
  },
  componentsPartOf: {
    fieldPath: 'qaSpecification.components.components.componentsPartOf',
  },
  manufacturer: {
    fieldPath: 'qaSpecification.components.components.manufacturer',
  },
  quantityInPercent: {
    fieldPath: 'qaSpecification.components.components.quantityInPercent',
  },
  totalWeight: {
    fieldPath: 'qaSpecification.components.components.totalWeight',
  },
  productClaims: {
    fieldPath: 'qaSpecification.components.productClaims',
  },

  // labeling
  isoCertifier: {
    fieldPath: 'qaSpecification.labeling.isoCertifier',
  },
  isoyn: {
    fieldPath: 'qaSpecification.labeling.isoyn',
  },
  kosherCertifier: {
    fieldPath: 'qaSpecification.labeling.kosherCertifier',
  },
  kosherYN: {
    fieldPath: 'qaSpecification.labeling.kosherYN',
  },
  halalYN: {
    fieldPath: 'qaSpecification.productSpecification.halalYN',
  },
  halalCertifier: {
    fieldPath: 'qaSpecification.labeling.halalCertifier',
  },
  nonGMOCertifier: {
    fieldPath: 'qaSpecification.labeling.nonGMOCertifier',
  },
  nonGMOYN: {
    fieldPath: 'qaSpecification.labeling.nonGMOYN',
  },
  organicCertifier: {
    fieldPath: 'qaSpecification.labeling.organicCertifier',
  },
  organicYN: {
    fieldPath: 'qaSpecification.labeling.organicYN',
  },
  brcCertifier: {
    fieldPath: 'qaSpecification.labeling.brcCertifier',
  },
  ifsCertifier: {
    fieldPath: 'qaSpecification.labeling.ifsCertifier',
  },
};
